import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AxsButtonComponent, AxsIconComponent } from '@vanguard/axs-angular';
import { ModalFunctions } from '@vanguard/axs-core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { AdobeLaunchService } from '../../adobe-launch/adobe-launch.service';

@Component({
  selector: 'research-summary-modal',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent, AxsIconComponent],
  templateUrl: './research-summary-modal.component.html',
  styleUrl: './research-summary-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ResearchSummaryModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Output() isOpenChange = new EventEmitter<boolean>();

  @ViewChild('modal') modal: any;
  @ViewChild('dialog') dialog: any;

  betrSummaryContent = content.Data.v4_rcc_root.content.betrSummary;
  needHelpContent = content.Data.v4_rcc_root.content.needHelp;
  commonContent = content.Data.v4_rcc_root.content.common;
  contentVisible = false;
  readonly researchPaperAfterSummaryDownloadTag =
    'ISGBETR:download full research paper after reading summary overview body1';

  constructor(
    private readonly contentService: ContentService,
    private readonly adobeLaunchService: AdobeLaunchService,
  ) {
    this.initializeContent();
  }

  initializeContent() {
    this.contentService.getContent().subscribe((data) => {
      this.betrSummaryContent = data.Data.v4_rcc_root.content.betrSummary;
      this.needHelpContent = data.Data.v4_rcc_root.content.needHelp;
      this.commonContent = data.Data.v4_rcc_root.content.common;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']?.currentValue) {
      this.contentVisible = false;
      setTimeout(() => this.openModal(), 0);
    }
  }

  openModal(): void {
    (this.modal.nativeElement as ModalFunctions).proxyShowModal();
    const modalContent = this.dialog.nativeElement.querySelector(
      '.research-summary-modal__content',
    );
    if (modalContent) {
      setTimeout(() => {
        this.contentVisible = true;
        modalContent.scrollTop = 0;
      }, 100);
    }
    this.dialog.nativeElement.addEventListener(
      'close',
      () => {
        this.onModalClosed();
      },
      { once: true },
    );
  }

  closeModal(): void {
    if (!this.isOpen) {
      return;
    }
    (this.modal.nativeElement as ModalFunctions).proxyClose();
  }

  onModalClosed(): void {
    this.contentVisible = false;
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }

  onDownloadResearchPaper(): void {
    this.adobeLaunchService.downloadAction(this.researchPaperAfterSummaryDownloadTag);
  }
}
